
Librarian.LibraryTreeWindow = new Class({
    Extends: Librarian.Window,
    Binds: ["onSelectClicked"],

    options: {
        id: "LibraryTreeWindow",
        width: 500,
        height: 610,
        treeType: "library",
        multiSelect: true,
        checkboxTypes: ["file"]
    },

    onComplete: null,
    treeViews: [],
    path: '',
    treeType: [],
    selectedContent: null,

    initialize: function(options) {
        this.setOptions(options);

        if (options)
            this.onComplete = options.onComplete;

        this.options.title = Librarian.Lang.getString("libtree_title");
        this.options.contentURL = Librarian.path.getLayoutsPath() + "pages/librarytree.html";

        this.path = options.path;
        this.treeType = Array.from(this.options.treeType);

        this.parent(options);
    },

    onWindowLoaded: function() {
        this.parent();
        this.setupElements();

        var itemEl = this.getElement("selectButton");
        if (itemEl)
            itemEl.addOnClick(this.onSelectClicked, this);

        itemEl = this.getElement("cancelButton");
        if (itemEl)
            itemEl.addOnClick(this.close);

        itemEl = this.getElement("treeCtrl");
        if (itemEl) {
            // Create each specified tree and add it to the window
            for (var i = 0, length = this.treeType.length; i < length; i++) {
                var tree;
                if (this.treeType[i] == "myfavorites") {
                    tree = this.getMyFavoritesTree(itemEl);
                }
                else if (this.treeType[i] == "globalfavorites") {
                    tree = this.getGlobalFavoritesTree(itemEl);
                }
                else if (this.treeType[i] == "uploads") {
                    tree = this.getUploadsTree(itemEl);

                    var buttonEl = this.getElement("uploadButton");
                    if (buttonEl) {
                        buttonEl.show();
                        buttonEl.tree = tree;
                        buttonEl.addOnClick(function() {
                            new Librarian.FileUploadWindow({
                                uploadUrl: Librarian.path.getUploadUrl("uplf") + "&out=json&publ=1&wait=1&comp=1",
                                onSuccess: function() {
                                    this.tree.reload();
                                }.bind(this)
                            }).show();
                        });
                    }
                }
                else if (this.treeType[i] == "creates")
                    tree = this.getCreationsTree(itemEl);
                else if (this.treeType[i] == "campaigns")
                    tree = this.getCampaignsTree(itemEl);
                else if (this.treeType[i] == "articles")
                    tree = this.getArticlesTree(itemEl);
                else if (this.treeType[i] == "slideShow")
                    tree = this.getSlideShowTree(itemEl);
                else if (this.treeType[i] == "userSlideShow")
                    tree = this.getUserSlideShowTree(itemEl);
                else
                    tree = this.getLibraryTree(itemEl, this.path);

                tree.addEvent("select", function(node) {
                    if (node.type != "file")
                        return;

                    var data = node.data;
                    data.name = node.name;

                    // If this is a virtual presentation with no Presentation ID, use the given File ID
                    if (!data.presid && data.ext && (data.ext == "vpres")) {
                        data.presid = data.fileid;
                        data.fileid = null;
                    }

                    if (this.options.multiSelect)
                        Librarian.PreviewWindow.openPreviewWindow(data);
                    else
                        this.selectedContent = data;
                }.bind(this));

                tree.addEvent("click", function(node) {
                    if (!node.isOpen() || node.isSelected())
                        node.toggle();
                });
                tree.load();

                this.treeViews.push(tree);
            }
        }
    },

    getLibraryTree: function(itemEl, path) {
        var params = null,
            rootCat = 0;
        if (path) {
            rootCat = -1;
            params = {
                cpath: path,
                pcid: 0
            };
        }

        return new Librarian.TreeView({
            allowNodeReselect: true,
            container: itemEl.id,
            checkBoxes: this.options.multiSelect,
            checkboxTypes: this.options.checkboxTypes,
            rootCat: rootCat,
            params: params
        });
    },


    getMyFavoritesTree: function(itemEl) {
        return new Librarian.TreeView({
            allowNodeReselect: true,
            container: itemEl.id,
            checkBoxes: this.options.multiSelect,
            checkboxTypes: ["file"],
            catType: Librarian.catType.myFavorite,
            method: "getvpcc",
            rootMethod: "getvpci",
            cookieStorage: false,
            rootCat: Librarian.specialCategories.UserFavorites

        });
    },

    getGlobalFavoritesTree: function(itemEl) {
        return new Librarian.TreeView({
            allowNodeReselect: true,
            container: itemEl.id,
            checkBoxes: this.options.multiSelect,
            checkboxTypes: ["file"],
            cookieStorage: false,
            catType: Librarian.catType.globalFavorite,
            rootCat: Librarian.specialCategories.GlobalFavorites.CatId,
            method: "getcg"
        });
    },

    getUploadsTree: function(itemEl) {
        return new Librarian.TreeView({
            allowNodeReselect: true,
            container: itemEl.id,
            checkBoxes: this.options.multiSelect,
            checkboxTypes: ["file"],
            method : "getcc",
            rootMethod : "getci",
            rootCat : Librarian.specialCategories.UserUploads,
            formatName: function(node, name) {
                if (node.isRoot())
                    return "Uploads";
                return name;
            },
            cookieStorage: false
        });
    },

    getCreationsTree: function(itemEl) {
        return new Librarian.TreeView({
            allowNodeReselect: true,
            container: itemEl.id,
            checkBoxes: this.options.multiSelect,
            checkboxTypes: ["file"],
            method: "getcc",
            rootMethod: "getci",
            rootCat: Librarian.specialCategories.UserApproved,
            formatName: function(node, name) {
                if (node.isRoot())
                    return "Creations";
                return name;
            },
            cookieStorage: false
        });
    },

    getCampaignsTree: function(itemEl) {
        return new Librarian.TreeView({
            allowNodeReselect: true,
            container: itemEl,
            checkBoxes: this.options.multiSelect,
            checkboxTypes: ["file"],
            catType: Librarian.catType.event,
            method: "getegcc",
            rootMethod: "getegci",
            url: Librarian.path.getEventUrl(),
            rootUrl: Librarian.path.getEventUrl(),
            cookieStorage: false
        });
    },

    getArticlesTree: function(itemEl) {
        return new Librarian.TreeView({
            allowNodeReselect: true,
            container: itemEl.id,
            checkBoxes: this.options.multiSelect,
            checkboxTypes: ["file"],
            catType: Librarian.catType.articles,
            rootCat: Librarian.specialCategories.Articles || -1,
            cookieStorage: false,
            params: {
                useweb: false
            }
        });
    },

    getSlideShowTree: function(itemEl) {
        return new Librarian.TreeView({
            allowNodeReselect: true,
            container: itemEl.id,
            checkBoxes: this.options.multiSelect,
            checkboxTypes: ["file"],
            catType: Librarian.catType.myFavorite,
            method: "getvpcc",
            rootMethod: "getvpci",
            cookieStorage: false,
            params: {
                type: Librarian.virtPresType.sharedSlideshow
            }
        });
    },

    getUserSlideShowTree: function(itemEl) {
        return new Librarian.TreeView({
            allowNodeReselect: true,
            container: itemEl.id,
            checkBoxes: this.options.multiSelect,
            checkboxTypes: ["file"],
            catType: Librarian.catType.myFavorite,
            method: "getvpcc",
            rootMethod: "getvpci",
            cookieStorage: false,
            params: {
                type: Librarian.virtPresType.slideshow
            }
        });
    },

    onSelectClicked: function() {
        var content = [];

        if (!this.options.multiSelect) {
            content = [this.selectedContent];
        }
        else if (this.treeViews) {
            // Get all checked files
            for (var i = this.treeViews.length; i--;) {
                if (this.treeViews[i]) {
                    var checked = this.treeViews[i].getChecked();
                    for (var j = checked.length; j--;) {
                        var data = checked[j].data;
                        data.name = checked[j].name;
                        content.push(data);
                    }
                }
            }
        }

        if (typeof this.onComplete == "function")
            this.onComplete(content);

        this.close();
    }
});